export default {
   actsurl: 'https://e-dziennik.men.gov.pl/wp-json/wp/v2/dziennik/',
   pageurl: 'https://e-dziennik.men.gov.pl/wp-json/wp/v2/pages/?slug='
}



// WEBPACK FOOTER //
// ./src/store/store2.js